export const ASSIGN = 1;
export const EDIT = 2;
export const REMOVE = 3;
export const VIEW = 4;
export const NO_ACTION = 5;
